import classNames from 'classnames';
import React from 'react';

import {useI18n} from '@udemy-v2/i18n';
import {Icon} from '@udemy-v2/icons';

import styles from './alternate-redirect.module.scss';

export const ALTERNATE_REDIRECT_REASON = {
    UPGRADED: 'upgraded',
    UNSUPPORTED: 'unsupported',
} as const;

export type AlternateRedirectReason =
    (typeof ALTERNATE_REDIRECT_REASON)[keyof typeof ALTERNATE_REDIRECT_REASON];

export interface AlternateRedirectProps {
    details?: {
        reason: AlternateRedirectReason;
        sourceCourseTitle: string;
    };
}

export const AlternateRedirect = ({details}: AlternateRedirectProps) => {
    const {gettext, interpolate} = useI18n();

    if (!details) {
        return null;
    }

    return (
        <div className={styles.container} role="alert">
            <div className={styles['icon-container']}>
                <Icon
                    className={styles.icon}
                    glyph="info"
                    size="medium"
                    color="info"
                    label="Info"
                />
            </div>
            {details.reason === ALTERNATE_REDIRECT_REASON.UPGRADED && (
                <div data-testid="course-alternate-reason-upgraded">
                    <div className="ud-heading-md">
                        {gettext('You have been redirected to the latest version of this course.')}
                    </div>
                    <div className={classNames('ud-text-sm', styles.subtext)}>
                        {gettext(
                            'If you have enrolled in an earlier version of this course, you can access it in "my courses".',
                        )}
                    </div>
                </div>
            )}
            {details.reason === ALTERNATE_REDIRECT_REASON.UNSUPPORTED && (
                <div data-testid="course-alternate-reason-unsupported">
                    <div className="ud-heading-md">
                        {interpolate(
                            gettext(
                                "%(title)s is not published on our platform at this time. You've been redirected to a similar course.",
                            ),
                            {title: details.sourceCourseTitle},
                            true,
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};
